import { render, staticRenderFns } from "./MagicStickButton.vue?vue&type=template&id=2ca62b6b&"
import script from "./MagicStickButton.vue?vue&type=script&lang=ts&"
export * from "./MagicStickButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports